import { Component } from '@angular/core';

@Component({
    selector: 'main-concerns',
    template: '<router-outlet></router-outlet>',
    standalone: false
})

export class MainConcernsComponent {
}
